import { render, staticRenderFns } from "./Cidades.vue?vue&type=template&id=26d95f56&"
import script from "./Cidades.vue?vue&type=script&lang=js&"
export * from "./Cidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports